import { FunctionBase } from './base/function-base';

export class Function extends FunctionBase { }